export default "__VITE_ASSET__D3qHRL5X__ 720w";